import { createRouter, createWebHistory } from 'vue-router'
import Start from '../components/Start.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Start
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
